var _a;
const Envs = {
  BFF_WEB_URL: (_a = process.env['NX_BFF_WEB_URL']) !== null && _a !== void 0 ? _a : process.env['REACT_APP_HUB_API']
};

export { Envs };
